// @flow strict
import React from 'react';
import { slugify } from '../../internal/util/slugify';

type PropTypes = {
  text: string,
};

const Section = ({ text }: PropTypes) => <section id={slugify(text)} />;
Section.displayName = 'Section';

export default Section;
